import fetchWrapper from './fetch-wrapper';
import clientIdCustom from './custom-client-id';
import getGeoIpData from '../localRepresentative/geoip-service';
import { setLanguage } from '../../copy/copy';
import { fillCard } from '../fillDynamicText';

let latitude;
let longitude;
getGeoIpData().then(data => {
    latitude = data.latitude;
    longitude = data.longitude;
});

function getActionsUrlOptions(
    apiBaseUrl,
    articleUrl,
    widgetPreviewId,
    widgetRequestId,
    embedType,
    sponsored
) {
    const request = {
        clientIdCustom,
        widgetEmbedType: embedType,
        articleUrlTracking: articleUrl,
        location: {
            latitude: latitude,
            longitude: longitude
        },
        sponsored: sponsored
    };

    if (widgetRequestId != null) {
        request.widgetRequestId = widgetRequestId;
    } else if (widgetPreviewId != null) {
        request.widgetPreviewId = widgetPreviewId;
    } else {
        request.articleUrl = articleUrl;
    }

    return {
        url: `${apiBaseUrl}Widget/GetActionsAsync`,
        options: {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        }
    };
}

export function parseActions(json) {
    const publisher = {
        id: (json || {}).publisherId,
        name: (json || {}).publisherName,
        twitterMention: (json || {}).twitterMention
    };
    if (json.hasOwnProperty('widgetLanguageId')) {
        setLanguage(json.widgetLanguageId);
    }
    let cards = json.cards || [];
    let index = 0;
    const orderValueMap = {};
    cards = cards
        .filter(function(a) {
            return a.actions.length > 0;
        })
        .reduce((cards, card) => {
            let orderValue;
            if (orderValueMap[card.order.value]) {
                orderValue = orderValueMap[card.order.value];
            } else {
                orderValue = ++index;
                orderValueMap[card.order.value] = orderValue;
            }
            cards.push({
                ...fillCard(card, publisher),
                order: {
                    type: card.order.type,
                    value: orderValue,
                    dependentActionId: card.order.dependentActionId,
                    dependentResultId: card.order.dependentResultId,
                    dependentActionType: card.order.dependentActionType
                }
            });
            return cards;
        }, []);

    const issue = json.widgetName || (json.data ? json.data.issue : null);
    let order = 1;
    let dependentActionType;
    let dependentActionId;
    let dependentResultId;
    let initialOrder;
    return {
        cards,
        // TODO try to remove actions, use cards instead
        actions: cards.reduce((a, b) => {
            dependentActionType = b.order.dependentActionType;
            dependentActionId = b.order.dependentActionId;
            dependentResultId = b.order.dependentResultId;
            initialOrder = b.order.value;
            b = b.actions.map(action => {
                return {
                    ...action,
                    order,
                    initialOrder,
                    dependentActionType,
                    dependentActionId,
                    dependentResultId,
                    widgetCardId: b.id,
                    cardOrderType: b.order.type,
                    cardCountdownTimer:
                        b.countdownTimer || b.countdownTimer === 0
                            ? b.countdownTimer
                            : action.type === 'Poll' || action.type === 'Quiz'
                                ? 2 //eslint-disable-line
                                : 6 //eslint-disable-line
                };
            });
            order += 1;
            return a.concat(b);
        }, []),
        issue,
        articleId: json.articleId,
        widgetId: json.widgetId,
        widgetRequestId: json.widgetRequestId,
        twitterMention: json.twitterMention,
        publisherId: json.publisherId,
        publisherKey: json.publisherKey,
        publisherName: json.publisherName,
        publisherDescription: json.publisherDescription,
        publishedDate: json.publishedDate,
        widgetType: json.widgetType,
        widgetHeading: json.widgetHeading,
        widgetSubHeading: json.widgetSubHeading,
        widgetLogoName: json.widgetLogoName,
        widgetName: json.widgetName,
        publisherLogoName: json.publisherLogoName,
        facebookPixelIds: json.facebookPixelIds,
        isSponsored: json.sponsored
    };
}

export function fetchActions(
    apiBaseUrl,
    articleUrl,
    widgetPreviewId,
    widgetRequestId,
    embedType,
    sponsored
) {
    const actionsUrlOptions = getActionsUrlOptions(
        apiBaseUrl,
        articleUrl,
        widgetPreviewId,
        widgetRequestId,
        embedType,
        sponsored
    );

    const actionsUrl = actionsUrlOptions.url;
    const options = actionsUrlOptions.options;
    return fetchWrapper(
        actionsUrl,
        Object.assign({}, options, {
            retries: 2
        })
    )
        .then(r => r.text().then(text => (text ? JSON.parse(text) : null)))
        .then(json => {
            if (json) {
                json.sponsored = json.sponsored || sponsored;
                return parseActions(json);
            }
        });
}

export default fetchActions;



// WEBPACK FOOTER //
// ./src/utils/old-riot-code/fetch-actions.js